import { jwtDecode } from 'jwt-decode';

//Access 토큰 만료 감지 함수

export function isTokenExpired(token) {
  if (!token) return true;
  try {
    const { exp } = jwtDecode(token);
    return Date.now() / 1000 > exp;
  } catch (e) {
    return true;
  }
}
